export { default } from "./RegistroCategorias";
